export const ACQUIRER_ROUTES = [
  //receivables
  '/recebimentos',
  '/recebimentos/${date}/detalhes',
  '/recebimentos/${date}/detalhes-do-pagamento',
  '/recebimentos/detalhes/${date}',
  '/recebimentos/detalhes-do-arranjo/${date}',
  '/recebimentos/detalhes-da-venda-split/${id}',
  '/recebimentos/detalhes-do-periodo',
  '/recebimentos/detalhes-do-periodo/detalhes-do-pagamento',
  //receivable accounts
  '/contas-de-recebimento',
  '/contas-de-recebimento/detalhes-da-conta',
  '/contas-de-recebimento/alterar-conta/escolha-as-unidades',
  '/contas-de-recebimento/alterar-conta/onde-quer-receber',
  '/contas-de-recebimento/alterar-conta/insira-o-cpf-do-titular',
  '/contas-de-recebimento/alterar-conta/informacoes-da-conta',
  '/contas-de-recebimento/alterar-conta/confirmacao-dos-dados',
  '/contas-de-recebimento/alterar-conta/autenticacao',
  '/contas-de-recebimento/alterar-conta/inserir-o-pin',
  '/contas-de-recebimento/alterar-conta/selecao-do-banco',
  '/contas-de-recebimento/alterar-conta/sucesso-na-alteracao',
  '/contas-de-recebimento/alterar-conta/falha-na-alteracao',
  '/contas-de-recebimento/alterar-conta/troca-bloqueada',
  '/contas-de-recebimento/alterar-conta/erro',
  '/contas-de-recebimento/historico',
  //receivable accounts v2
  '/contas-de-recebimento/v2',
  '/contas-de-recebimento/v2/${paymentProfileId}',
  '/contas-de-recebimento/v2/${paymentProfileId}/detalhes/${poiType}',
  '/contas-de-recebimento/v2/${paymentProfileId}/historico/${poiType}',
  // terminals
  '/maquininhas',
  '/maquininhas/cobrancas',
  '/maquininhas/isencao-por-volume',
  '/maquininhas/${type}/pedido-de-ajuda/problema',
  '/maquininhas/pedidos/${id}',
  '/maquininhas/novo-pedidos/${id}',
  '/maquininhas/novo-pedido-de-bobina/endereco',
  '/maquininhas/novo-pedido-de-bobina/novo-endereco',
  '/maquininhas/novo-pedido-de-bobina/horarios',
  '/maquininhas/novo-pedido-de-bobina/telefone',
  '/maquininhas/novo-pedido-de-bobina/revisao',
  '/maquininhas/novo-pedido-de-bobina/sucesso',
  '/maquininhas/historico-completo',
  '/maquininhas/nova-isencao-por-volume',
  '/maquininhas/nova-home',
  '/maquininhas/mensalidades',
  '/maquininhas/outras-cobrancas',
  '/maquininhas/tipo-de-pedido',
  '/maquininhas/escolha-a-maquininha',
  //rav
  '/antecipacao',
  '/antecipacao/historico',
  '/antecipacao/pontual/formulario',
  '/antecipacao/pontual/confirmar',
  '/antecipacao/pontual/challenge',
  '/antecipacao/pontual/sucesso',
  '/antecipacao/automatica/selecionar',
  '/antecipacao/automatica/confirmar',
  '/antecipacao/automatica/challenge',
  '/antecipacao/automatica/sucesso',
  '/antecipacao/automatica/cancelamento',
  '/antecipacao/automatica/cancelamento-sucesso',
  '/antecipacao/automatica/detalhes',
  '/antecipacao/recebimento-diario/confirmar',
  '/antecipacao/recebimento-diario/challenge',
  '/antecipacao/recebimento-diario/detalhes',
  '/antecipacao/recebimento-mesmo-dia/confirmar',
  '/antecipacao/recebimento-mesmo-dia/challenge',
  '/antecipacao/recebimento-mesmo-dia/detalhes',

  //vendas
  '/vendas',
  '/vendas/contestacoes',
  '/vendas/contestacoes/${id}',
  '/vendas/contestacoes/${id}/disputa-individual',
  '/vendas/cancelamento/formulario',
  '/vendas/captura/formulario',
  '/vendas/retentativa/senha',
  '/simular-venda',
  '/vendas/contestacoes',
  //smb
  '/tarifas',
  '/tarifas/tarifas-de-vendas',
  '/tarifas/tarifas-de-contas',
  //receivables-contracts
  '/contratos-de-recebiveis/contratos',
  '/contratos-de-recebiveis/detalhes-do-contrato',
  '/contratos-de-recebiveis/contestar-contrato',
  '/contratos-de-recebiveis/detalhes',
  '/contratos-por-instituicao',
  '/contratos-por-instituicoes/instituicao',
  '/contratos-por-instituicoes/contratos',
  //reports
  '/relatorios/tipos-de-relatorio',
  '/relatorios/enviar-relatorio',
  '/relatorios/baixar-relatorio',
  '/relatorios/erro-ao-enviar-relatorio',
  '/relatorios/erro',
  '/relatorios/raio-x',
  //sak-keys
  '/chaves-de-autenticacao',
  '/chaves-de-autenticacao/criar-chave',
  '/chaves-de-autenticacao/excluir-chave/autenticacao',
  '/chaves-de-autenticacao/excluir-chave/sucesso',
  '/chaves-de-autenticacao/excluir-chave/erro',
  //auto-cred
  '/raio-x/auto-credenciamento',

  // payment-link
  '/link-de-pagamento',
  '/link-de-pagamento/criar'
] as const
